import { httpClient } from '@/utils/http-client'
import { logger } from '@/utils/logger'

export const getForwardToNotarizationLink = async () => {
    logger.info('Retrieving forward to notarization link')
    return await httpClient.get('/remoteNotarization/scheduling/getForwardToNotarizationLink')
}
